import { Auth } from 'aws-amplify';

export default {
  signIn(username, password) {
    return Auth.signIn(username, password)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },

  signOut() {
    return Auth.signOut()
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },

  getCurrentUserInfo() {
    return Auth.currentUserInfo()
      .then((user) => user)
      .catch((error) => error);
  },

  getCurrentAuthenticatedUser() {
    return Auth.currentAuthenticatedUser()
      .then((user) => user)
      .catch((error) => error);
  },

  getCurrentSession() {
    return Auth.currentSession()
      .then((user) => user)
      .catch((error) => error);
  },

  completeNewPassword(user, newPassword) {
    return Auth.completeNewPassword(user, newPassword)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },

  forgotPassword(username) {
    return Auth.forgotPassword(username)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },

  forgotPasswordSubmit(username, code, newPassword) {
    return Auth.forgotPasswordSubmit(username, code, newPassword)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },

  verifyUserAttribute(user, attribute) {
    return Auth.verifyUserAttribute(user, attribute)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },

  verifyUserAttributeSubmit(user, attribute, code) {
    return Auth.verifyUserAttributeSubmit(user, attribute, code)
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },

  signUp(username, password, email, firstName, lastName) {
    return Auth.signUp({
      username,
      password,
      attributes: {
        email,
        given_name: firstName,
        family_name: lastName,
      },
    })
      .then((response) => response)
      .catch((error) => Promise.reject(error));
  },

  fetchAnnouncements() {
    return Promise.resolve([]);
  },
};
